import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledLoadingContainer = styled(Box)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(255,255,255,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 2,
  zIndex: 2,
}));

export const StyledErrorContainer = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 2,
}));
